<!-- =========================================================================================
		File Name: KnowledgeBase.vue
		Description: Knowledge Base Page
		----------------------------------------------------------------------------------------
		Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
			Author: Pixinvent
		Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="knowledge-base-page" class="w-full">
    <vs-button type="flat" @click="$router.go(-1)">&lt; {{ $t("action.back") }}</vs-button>
    <vs-divider />
    <help-center-filter
      v-bind:title="$t('helpCenter.howCanWeHelp')"
      v-bind:desc="$t('helpCenter.useKeywordArticle')"
      class="mb-base"
      :groupId="group.id"
      :key="filter_key"
    />
    <vx-card :title="group.name">
      <template v-if="group.articles.length > 0">
        <vs-collapse :type="`margin`" accordion>
          <vs-collapse-item v-for="article in group.articles" :key="article.slug">
            <div slot="header">{{ article.title }}</div>
            <div class="article-body text-xl mb-3" v-html="article.body"></div>
            <p class="text-right mb-3">
              {{ $t("attribute.lastUpdated") }} : {{ renderToHumanDate(article.updated_at) }}
            </p>
          </vs-collapse-item>
        </vs-collapse>
      </template>
      <template v-else>
        <div class="text-center">
          <i>--- {{ $t("general.notAvailable", { msg: $t("attribute.article") }) }} ---</i>
        </div>
      </template>
    </vx-card>
  </div>
</template>

<style scoped>
.article-body /deep/ span {
  font-size: 12pt !important;
}
</style>

<script>
import Global from "@/helper/global";
import Crypto from "@/helper/crypto";
import ErrorHandler from "@/helper/error_handler";
import HelpCenterFilter from "./HelpCenterFilter.vue";

export default {
  data() {
    return {
      api_errors: [],
      group: {
        id: 0,
        name: "",
        articles: [],
      },
      filter_key: 1,
      isAuth: false,
    };
  },
  components: {
    HelpCenterFilter,
  },
  created() {
    this.isAuth = this.$store.getters.isLoggedIn;
  },
  mounted() {
    this.retrieveGroupDetails();
  },
  methods: {
    retrieveGroupDetails() {
      this.api_errors = [];

      this.$vs.loading({
        type: "radius",
      });

      let url = this.$endpoints.article_group + "/" + this.$route.params.group_id;

      this.$http
        .get(url)
        .then((res) => {
          this.group = res.data.data;
          this.filter_key++;
        })
        .catch((err) => {
          this.api_errors = ErrorHandler.processErrorMessage(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
};
</script>
